<div class="diretoria-prestador-container">
    <app-card-content [border]="false" [headerColor]="true" icon="pi pi-users" title="Diretoria Atual" subtitle="Diretores técnicos e clínicos do prestador">
        <div card-header class="inline-flex items-center gap-2">
            <app-botao-acoes label="Ações" [iconPos]="EInconPos.LEFT" [items]="itensAcoes" [destaque]="itensEdicao" [destaqueAtivo]="isEditing" [iconColumns]="2" [permissaoUf]="pessoa()?.uf ?? null" />
        </div>

        <form [formGroup]="form">
            <div class="flex flex-col gap-4">
                <!-- Os quatro cargos têm o mesmo desenho e diferem só no prefixo dos campos e no
                     título — declarados uma vez no `#cargoDiretor`, no fim deste bloco. Antes eram
                     quatro cópias do mesmo markup, e qualquer ajuste de layout precisava ser feito
                     nas quatro. -->
                <ng-container *ngTemplateOutlet="cargoDiretor; context: { prefixo: 'dt', icone: 'pi pi-user', titulo: 'Diretor Técnico' }"></ng-container>
                <ng-container *ngTemplateOutlet="cargoDiretor; context: { prefixo: 'dts', icone: 'pi pi-user-plus', titulo: 'Diretor Técnico Substituto' }"></ng-container>
                <ng-container *ngTemplateOutlet="cargoDiretor; context: { prefixo: 'dc', icone: 'pi pi-user-edit', titulo: 'Diretor Clínico' }"></ng-container>
                <ng-container *ngTemplateOutlet="cargoDiretor; context: { prefixo: 'vdc', icone: 'pi pi-user', titulo: 'Vice Diretor Clínico' }"></ng-container>

                <ng-template #cargoDiretor let-prefixo="prefixo" let-icone="icone" let-titulo="titulo">
                    <app-card-content [headerColor]="true" [icon]="icone" [title]="titulo">
                        <!-- Corpo em duas colunas: o retrato à esquerda, em container próprio, e o
                             formulário à direita. O retrato se estica na altura do corpo; sem médico
                             no cargo ele não sai, e o formulário fica com a largura toda. -->
                        <div class="diretor-corpo">
                            <app-foto-diretor [nome]="form.get(prefixo + 'Nome')?.value" [crm]="form.get(prefixo + 'Crm')?.value" [uf]="form.get(prefixo + 'Uf')?.value" />

                            <div class="diretor-campos">
                                <div class="flex flex-row flex-wrap gap-3">
                                    <div class="flex-1 min-w-[8rem] max-w-[12rem]">
                                        <label class="font-semibold block mb-2">CRM</label>
                                        <input pInputText [formControlName]="prefixo + 'Crm'" class="w-full" />
                                    </div>
                                    <div class="flex-[5] min-w-[16rem]">
                                        <label class="font-semibold block mb-2">Nome</label>
                                        <input pInputText [formControlName]="prefixo + 'Nome'" class="w-full" />
                                    </div>
                                </div>

                                <div class="flex flex-row flex-wrap gap-3">
                                    <div class="flex-1 min-w-[6rem] max-w-[10rem]">
                                        <label class="font-semibold block mb-2">UF</label>
                                        <input pInputText [formControlName]="prefixo + 'Uf'" class="w-full" />
                                    </div>
                                    <app-form-date-picker [label]="'Entrada'" [control]="form.get(prefixo + 'Entrada')" />
                                    <app-form-date-picker [label]="'Saída'" [control]="form.get(prefixo + 'Saida')" />
                                </div>
                            </div>
                        </div>
                    </app-card-content>
                </ng-template>

                @if (diretoresFuturos.length) {
                    <app-card-content [headerColor]="true" icon="pi pi-calendar-clock" title="Diretores Futuros">
                        <p class="m-0 mb-4 text-600">Agendamentos futuros não aparecem como diretoria atual. Ao alterar ou substituir o diretor atual do mesmo cargo, será necessário confirmar a remoção do agendamento futuro.</p>
                        <p-table [value]="diretoresFuturos" [paginator]="false" [rows]="10" styleClass="w-full">
                            <ng-template pTemplate="header">
                                <tr>
                                    <th class="w-24">Ações</th>
                                    <th class="w-16">UF</th>
                                    <th class="w-28">CRM</th>
                                    <th>Nome do Médico</th>
                                    <th class="w-48">Cargo</th>
                                    <th class="w-28">Entrada</th>
                                    <th class="w-28">Saída</th>
                                </tr>
                            </ng-template>
                            <ng-template pTemplate="body" let-row>
                                <tr>
                                    <td><p-button icon="pi pi-dollar" severity="secondary" text rounded (onClick)="abrirArrecadacaoFuturo(row)" /></td>
                                    <td>{{ row.uf }}</td>
                                    <td>{{ row.crm }}</td>
                                    <td>{{ row.nome }}</td>
                                    <td>{{ row.cargo }}</td>
                                    <td>{{ row.entrada }}</td>
                                    <td>{{ row.saida }}</td>
                                </tr>
                            </ng-template>
                        </p-table>
                    </app-card-content>
                }

                <!-- Composição Antiga da Diretoria -->
                <app-card-content [headerColor]="true" icon="pi pi-list" title="Composição Antiga">
                    <p-table [value]="historicoDiretoria" [paginator]="false" [rows]="10" styleClass="w-full">
                        <ng-template pTemplate="header">
                            <tr>
                                <th class="w-24">Ações</th>
                                <th class="w-16">UF</th>
                                <th class="w-28">CRM</th>
                                <th>Nome do Médico</th>
                                <th class="w-48">Cargo</th>
                                <th class="w-28">Entrada</th>
                                <th class="w-28">Saída</th>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="body" let-row>
                            <tr>
                                <td class="whitespace-nowrap">
                                    <p-button icon="pi pi-dollar" severity="secondary" text rounded (onClick)="abrirArrecadacaoHistorico(row)" />
                                    @if (isEditing) {
                                        <p-button icon="pi pi-trash" severity="danger" text rounded [disabled]="carregando()" (onClick)="abrirConfirmacaoRemocaoHistorico(row)" />
                                    }
                                </td>
                                <td>{{ row.uf }}</td>
                                <td>{{ row.crm }}</td>
                                <td>{{ row.nome }}</td>
                                <td>{{ row.cargo }}</td>
                                <td>{{ row.entrada }}</td>
                                <td>{{ row.saida }}</td>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="emptymessage">
                            <tr>
                                <td [attr.colspan]="7" class="text-center py-4 text-500">Nenhum registro encontrado</td>
                            </tr>
                        </ng-template>
                    </p-table>
                </app-card-content>
            </div>
        </form>
    </app-card-content>

    <p-dialog
        appDialogoPadrao="pi pi-wallet"
        descricao="Pendências financeiras dos diretores da composição."
        [(visible)]="debitosDiretoriaDialog"
        [breakpoints]="{ '1100px': '75vw', '500px': '90vw' }"
        header="Diretores com débitos"
        styleClass="dialog-fullscreen-mobile"
        [maximizable]="true"
        [appendTo]="'body'"
    >
        <ng-template #content>
            <div class="p-fluid formgrid grid">
                <div class="grid grid-cols-1 gap-4 w-full">
                    <div class="field">
                        <label class="font-semibold block mb-2">Selecione um diretor para abrir a arrecadação</label>

                        @if (carregandoDebitos()) {
                            <div class="border border-surface-200 rounded-lg p-4 text-600 flex items-center gap-2">
                                <i class="pi pi-spin pi-spinner"></i>
                                Consultando débitos pendentes da diretoria...
                            </div>
                        } @else if (diretoresComDebitos.length) {
                            <p-listbox
                                [filter]="true"
                                [filterFields]="['nome', 'crm', 'uf', 'cargo']"
                                filterPlaceholder="Pesquisar"
                                [options]="diretoresComDebitos"
                                optionLabel="nome"
                                styleClass="w-full"
                                [listStyle]="{ 'max-height': '24rem' }"
                                (onChange)="abrirArrecadacaoDiretor($event.value)"
                            >
                                <ng-template let-item pTemplate="item">
                                    <div class="grid grid-cols-[1fr_auto] gap-4 items-center w-full">
                                        <div class="min-w-0">
                                            <div class="font-bold truncate">{{ item.nome }}</div>
                                            <div class="text-sm text-600">{{ item.cargo }} - CRM {{ item.crm }}/{{ item.uf }}</div>
                                        </div>
                                        <div class="flex items-center gap-2">
                                            <span class="text-sm font-semibold text-orange-500">{{ item.totalDebitos }} pendente(s)</span>
                                            <i class="pi pi-angle-right text-primary"></i>
                                        </div>
                                    </div>
                                </ng-template>
                            </p-listbox>
                        } @else {
                            <div class="border border-surface-200 rounded-lg p-4 text-600">Nenhum diretor atual com débitos pendentes foi encontrado.</div>
                        }
                    </div>
                </div>
            </div>
        </ng-template>

        <ng-template #footer>
            <p-button label="Fechar" icon="pi pi-times" text (click)="debitosDiretoriaDialog = false" />
        </ng-template>
    </p-dialog>

    <p-dialog appDialogoPadrao="pi pi-users" descricao="A partir de quando a nova diretoria assume." header="Data de substituição" [(visible)]="substituicaoDataDialog" [closable]="false" [style]="{ width: '28rem', maxWidth: '95vw' }">
        <div class="flex flex-col gap-4">
            <p class="m-0 text-600">Informe a data em que o diretor atual será encerrado e o novo médico assumirá o cargo.</p>
            <app-form-date-picker [label]="'Data de substituição'" [control]="dataSubstituicaoControl" />
        </div>
        <ng-template pTemplate="footer">
            <p-button label="Cancelar" severity="secondary" type="button" (onClick)="cancelarDataSubstituicao()" />
            <p-button label="Pesquisar médico" icon="pi pi-search" type="button" (onClick)="confirmarDataSubstituicao()" />
        </ng-template>
    </p-dialog>

    <p-dialog appDialogoPadrao="pi pi-users" descricao="Revise a composição antes de gravar." header="Confirmar alteração da diretoria" [(visible)]="confirmacaoDiretorFuturoDialog" [closable]="false" [style]="{ width: '46rem', maxWidth: '95vw' }">
        <div class="flex flex-col gap-4">
            <p class="m-0 text-600">Existe diretor futuro agendado para o mesmo cargo. Se confirmar, a alteração que você está fazendo agora terá prioridade, o diretor atual será mantido/alterado conforme abaixo e o diretor futuro será removido.</p>

            @for (conflito of conflitosDiretoresFuturos; track conflito.cargo) {
                <div class="border border-orange-200 rounded-lg p-4 bg-orange-50">
                    <div class="font-semibold text-orange-700 mb-3">{{ conflito.cargoLabel }}</div>
                    <div class="grid grid-cols-1 md:grid-cols-3 gap-3">
                        <div>
                            <div class="text-sm font-semibold text-600 mb-1">Atual</div>
                            <div>{{ diretorResumo(conflito.atual) }}</div>
                            <div class="text-sm text-600">Entrada: {{ formatarData(conflito.atual.dtInicial) }}</div>
                            <div class="text-sm text-600">Saída: {{ formatarData(conflito.atual.dtFinal) }}</div>
                        </div>
                        <div>
                            <div class="text-sm font-semibold text-600 mb-1">Futuro que será removido</div>
                            <div>{{ diretorResumo(conflito.futuro) }}</div>
                            <div class="text-sm text-600">Entrada: {{ formatarData(conflito.futuro.dtInicial) }}</div>
                            <div class="text-sm text-600">Saída: {{ formatarData(conflito.futuro.dtFinal) }}</div>
                        </div>
                        <div>
                            <div class="text-sm font-semibold text-600 mb-1">Alteração solicitada</div>
                            <div>{{ diretorResumo(conflito.alteracaoDiretor) }}</div>
                            <div class="text-sm text-600">Entrada: {{ formatarData(conflito.alteracao.dtInicial) }}</div>
                            <div class="text-sm text-600">Saída: {{ formatarData(conflito.alteracao.dtFinal) }}</div>
                        </div>
                    </div>
                </div>
            }
        </div>
        <ng-template pTemplate="footer">
            <p-button label="Cancelar" severity="secondary" type="button" (onClick)="cancelarResolucaoDiretoresFuturos()" />
            <p-button label="Confirmar e remover futuro" severity="warn" icon="pi pi-check" type="button" (onClick)="confirmarResolucaoDiretoresFuturos()" />
        </ng-template>
    </p-dialog>

    <p-dialog appDialogoPadrao="pi pi-users" descricao="Outro diretor já ocupa este cargo na composição." header="Cargo já ocupado" [(visible)]="confirmacaoCargoOcupadoDialog" [closable]="false" [style]="{ width: '38rem', maxWidth: '95vw' }">
        <div class="flex flex-col gap-4">
            <p class="m-0 text-600">{{ mensagemConflitoCargoOcupado }}</p>
            <p class="m-0 text-600">O mandato do diretor atual será encerrado e o novo diretor assumirá a partir da data de entrada informada.</p>
        </div>
        <ng-template pTemplate="footer">
            <p-button label="Cancelar" severity="secondary" type="button" (onClick)="cancelarSubstituicaoCargoOcupado()" />
            <p-button label="Confirmar substituição" severity="warn" icon="pi pi-check" type="button" (onClick)="confirmarSubstituicaoCargoOcupado()" />
        </ng-template>
    </p-dialog>

    <p-dialog
        appDialogoPadrao="pi pi-users"
        descricao="O diretor sai da composição anterior."
        header="Remover diretor da composição antiga"
        [(visible)]="confirmacaoRemocaoHistoricoDialog"
        [closable]="false"
        [style]="{ width: '34rem', maxWidth: '95vw' }"
    >
        <div class="flex flex-col gap-4">
            <p class="m-0 text-600">Esta ação não poderá ser desfeita. Confirme a remoção do registro histórico selecionado.</p>

            @if (historicoSelecionadoParaRemocao) {
                <div class="border border-red-200 rounded-lg p-4 bg-red-50">
                    <div class="font-semibold text-red-700 mb-2">{{ historicoSelecionadoParaRemocao.nome }}</div>
                    <div class="text-sm text-600">CRM: {{ historicoSelecionadoParaRemocao.crm }} / {{ historicoSelecionadoParaRemocao.uf }}</div>
                    <div class="text-sm text-600">Cargo: {{ historicoSelecionadoParaRemocao.cargo }}</div>
                    <div class="text-sm text-600">Entrada: {{ historicoSelecionadoParaRemocao.entrada }}</div>
                    <div class="text-sm text-600">Saída: {{ historicoSelecionadoParaRemocao.saida }}</div>
                </div>
            }
        </div>
        <ng-template pTemplate="footer">
            <p-button label="Cancelar" severity="secondary" type="button" (onClick)="cancelarRemocaoHistorico()" />
            <p-button label="Remover" severity="danger" icon="pi pi-trash" type="button" [disabled]="carregando()" (onClick)="confirmarRemocaoHistorico()" />
        </ng-template>
    </p-dialog>

    <!-- Seleção de qual mandato excluir (legado: frmSelecionaDiretor, "Composição Diretoria").
         Lista todos os cargos porque o banco pode ter mais de um diretor no mesmo cargo, e é aí
         que a escolha do usuário decide qual linha some. -->
    <p-dialog appDialogoPadrao="pi pi-users" descricao="O diretor sai da composição atual." header="Excluir diretor da composição" [(visible)]="selecaoExclusaoDialog" [style]="{ width: '52rem', maxWidth: '95vw' }">
        <div class="flex flex-col gap-4">
            <p class="m-0 text-600">Selecione o mandato que deseja excluir. A exclusão apaga o vínculo do prestador — para apenas encerrar o mandato, informe a data de saída pela edição.</p>

            @if (carregando()) {
                <div class="border border-surface-200 rounded-lg p-4 text-600 flex items-center gap-2">
                    <i class="pi pi-spin pi-spinner"></i>
                    Carregando mandatos da diretoria...
                </div>
            } @else {
                <p-table [value]="mandatosParaExclusao" [paginator]="false" [rows]="10" styleClass="w-full">
                    <ng-template pTemplate="header">
                        <tr>
                            <th class="w-24">Ações</th>
                            <th class="w-16">UF</th>
                            <th class="w-28">CRM</th>
                            <th>Nome do Médico</th>
                            <th class="w-48">Cargo</th>
                            <th class="w-28">Entrada</th>
                            <th class="w-28">Saída</th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-row>
                        <tr>
                            <td><p-button icon="pi pi-trash" severity="danger" text rounded (onClick)="selecionarMandatoParaExclusao(row)" /></td>
                            <td>{{ row.uf }}</td>
                            <td>{{ row.crm }}</td>
                            <td>{{ row.nome }}</td>
                            <td>{{ row.cargo }}</td>
                            <td>{{ row.entrada }}</td>
                            <td>{{ row.saida }}</td>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="emptymessage">
                        <tr>
                            <td [attr.colspan]="7" class="text-center py-4 text-500">Nenhum mandato vigente para excluir</td>
                        </tr>
                    </ng-template>
                </p-table>
            }
        </div>
        <ng-template pTemplate="footer">
            <p-button label="Fechar" icon="pi pi-times" text type="button" (onClick)="cancelarSelecaoExclusao()" />
        </ng-template>
    </p-dialog>

    <p-dialog appDialogoPadrao="pi pi-users" descricao="A exclusão não pode ser desfeita." header="Confirmar exclusão do diretor" [(visible)]="confirmacaoExclusaoVigenteDialog" [closable]="false" [style]="{ width: '34rem', maxWidth: '95vw' }">
        <div class="flex flex-col gap-4">
            <p class="m-0 text-600">Esta ação não poderá ser desfeita. O mandato será apagado do cadastro, sem registro na composição antiga.</p>

            @if (mandatoSelecionadoParaExclusao) {
                <div class="border border-red-200 rounded-lg p-4 bg-red-50">
                    <div class="font-semibold text-red-700 mb-2">{{ mandatoSelecionadoParaExclusao.nome }}</div>
                    <div class="text-sm text-600">CRM: {{ mandatoSelecionadoParaExclusao.crm }} / {{ mandatoSelecionadoParaExclusao.uf }}</div>
                    <div class="text-sm text-600">Cargo: {{ mandatoSelecionadoParaExclusao.cargo }}</div>
                    <div class="text-sm text-600">Entrada: {{ mandatoSelecionadoParaExclusao.entrada }}</div>
                    <div class="text-sm text-600">Saída: {{ mandatoSelecionadoParaExclusao.saida || '-' }}</div>
                </div>
            }
        </div>
        <ng-template pTemplate="footer">
            <p-button label="Cancelar" severity="secondary" type="button" (onClick)="cancelarExclusaoVigente()" />
            <p-button label="Excluir" severity="danger" icon="pi pi-trash" type="button" [disabled]="carregando()" (onClick)="confirmarExclusaoVigente()" />
        </ng-template>
    </p-dialog>

    <app-pesquisa [(showDialog)]="pesquisaMedicoDialog" [tipoFixo]="'MEDICO'" [apenasAtivos]="true" (pessoa)="selecionarMedicoSubstituto($event)"></app-pesquisa>

    <app-seletor-medico-corpo-clinico [(showDialog)]="corpoClinicoDialog" [idPrestador]="pessoa()?.id ?? 0" [ufPrestador]="pessoa()?.uf ?? ''" (medico)="selecionarMedicoSubstituto($event)"></app-seletor-medico-corpo-clinico>
</div>
